import React, {useState} from 'react';

function Pagination({ itemsPerPage, totalItems, paginate, currentPage }) {
  const [inputValue, setInputValue] = useState('');
  const [inputPage, setInputPage] = useState('');

  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handleGoClick = () => {
    const pageNumber = Number(inputPage);
    if (pageNumber >= 1 && pageNumber <= pageNumbers.length) {
      paginate(pageNumber);
    }
    setInputValue('');
  };

  let start = currentPage;
  let end = currentPage + 4;

  if (currentPage > pageNumbers.length - 5) {
    start = Math.max(1, pageNumbers.length - 5);
  }

  if (end > pageNumbers.length) {
    end = pageNumbers.length;
  }

  return (
      <div className='page-footers'>
        <div id="pagination">
          <li>
            <button onClick={() => paginate(1)} disabled={currentPage === 1} className={`${currentPage === 1 ? 'disable' : ''}`}>
              &lt;&lt;
            </button>
          </li>
          <li>
            <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className={`${currentPage === 1 ? 'disable' : ''}`}>
              prev
            </button>
          </li>
          {start > 2 && <li style={{textAlign: "center"}}>...</li>}
          {start === 2 &&
              <li className = "number1">
                <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''} id={currentPage === 1 ? '' : "page-numbers"}>
                  1
                </button>
              </li>
          }

          {pageNumbers.slice(start - 1, end).map(number => (
              <li className = "numberlist" key={number}>
                <button onClick={() => paginate(number)} className={currentPage === number ? 'active' : ''} id={currentPage === number ? '' : "page-numbers"}>
                  {number}
                </button>
              </li>
          ))}
          {end < pageNumbers.length - 1 && <li style={{textAlign: "center"}}>...</li>}
          {end < pageNumbers.length &&
              <li>
                <button onClick={() => paginate(pageNumbers.length)} className={currentPage === pageNumbers.length ? 'active' : ''} id={currentPage === pageNumbers.length ? '' : "page-numbers"}>
                  {pageNumbers.length}
                </button>
              </li>
          }
          <li>
            <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === pageNumbers.length} className={`${currentPage === pageNumbers.length ? 'disable' : ''}`}>
              next
            </button>
          </li>
          <li>
            <button onClick={() => paginate(pageNumbers.length)} disabled={currentPage === pageNumbers.length} className={`${currentPage === pageNumbers.length ? 'disable' : ''}`}>
              &gt;&gt;
            </button>
          </li>
          {/*<div className="go-container">
        <button className="page-rec-go" onClick={handleGoClick} >go to page</button>
          <input className="page-rec" type="number" value={inputValue} onChange={e => {
            setInputPage(e.target.value);
            setInputValue(e.target.value);
          }}/>
        </div>*/}
        </div>
      </div>
  );
}

export default Pagination;